import {
  dateOfBirthToDate,
  dateOfBirthToIso,
} from "../../components/DateOfBirthInput";
import type { CardData } from "./machine";

/**
 * Decodes the card's birth date to a calendar date (`YYYY-MM-DD`). Card reads
 * may deliver a midnight timestamp (`2000-10-01T00:00:00.000Z`); only the date
 * is meaningful. A value that is not a valid date becomes `""`, so the
 * registration form asks for it instead of showing raw text (KC-74, KC-16).
 *
 * @since 1.3.0
 * @example
 * ```ts
 * cardBirthDateToIsoDate("2000-10-01T00:00:00.000Z"); // "2000-10-01"
 * ```
 */
export function cardBirthDateToIsoDate(value: string): string {
  const date = dateOfBirthToDate(value);
  return date === undefined ? "" : dateOfBirthToIso(date);
}

/**
 * The check-in flow's ingress for card demographics: everything downstream
 * (registration review, edit form, create call) consumes the decoded shape and
 * never re-parses the birth date.
 *
 * @since 1.3.0
 * @example
 * ```ts
 * send({ type: "REGISTER_FROM_CARD", cardData: toCheckInCardData(result.cardData), crlogId });
 * ```
 */
export function toCheckInCardData(cardData: CardData): CardData {
  return { ...cardData, birthDate: cardBirthDateToIsoDate(cardData.birthDate) };
}
